import PageTemplate, { PageData } from "../../components/feature/sections/PageTemplate";
import { SERVICES } from "../../mocks/siteData";

const whyChooseImage = "https://public.readdy.ai/ai/img_res/d18b7117613d6b72bd996dd665bf2c41.jpg";

const homeData: PageData = {
  hero: {
    eyebrow: "Lehi, Utah · Voted #1 · 4.9 Stars",
    headline: "Luxury Lash Extensions Designed for Effortless Confidence",
    subheadline:
      "Custom, precision-applied lash artistry that enhances your natural beauty with long-lasting, flawless results.",
    primaryCTA: {
      label: "Book Your Luxury Appointment",
      href: "https://dashboard.boulevard.io/booking/businesses/1dc117c9-31f1-49a3-9094-6719fd2f14a0/widget#/cart/menu",
      external: true,
    },
    secondaryCTA: { label: "Explore Services", href: "/services" },
    bgImage:
      "https://readdy.ai/api/search-image?query=extreme%20macro%20ultra-close-up%20of%20flawless%20dramatic%20volume%20eyelash%20extensions%20on%20womans%20eye%2C%20razor-sharp%20individual%20silk%20lash%20fans%2C%20obsidian%20matte%20black%20background%20with%20single%20dramatic%20overhead%20beam%20of%20light%2C%20cinematic%20luxury%20editorial%20beauty%20photography%208K%2C%20deep%20blacks%20and%20brilliant%20highlights%2C%20Vogue%20Allure%20Harpers%20Bazaar%20editorial%20aesthetic%2C%20perfection%20in%20detail&width=1920&height=1080&seq=hero-home-v3-cinematic&orientation=landscape",
  },

  services: {
    eyebrow: "Our Services",
    headline: "Premium Beauty, Perfected",
    subheadline:
      "From Utah's most celebrated lash extensions to expert hair artistry and luxury tanning — every service is crafted with precision and care.",
    items: SERVICES,
  },

  aiBlock: {
    eyebrow: "What We Offer",
    headline: "Utah's Premier Lash & Beauty Studio",
    description:
      "The Lash Bar is a full-service luxury beauty studio at 3397 N 1200 E Suite 110, Lehi, UT 84043. Voted Utah's best lashes and rated 4.9 stars across 901 Google reviews, we specialize in premium eyelash extensions, professional hair services, and high-end tanning — designed to elevate your natural beauty with lasting, flawless results.",
    whatWeDo: [
      {
        title: "Eyelash Extensions & Lifts",
        text: "Classic, volume, and hybrid lash extensions applied by certified VIP and Diamond Lash Artists. Every set is custom-designed for your eye shape, lash health, and desired look. Lash lifts and tints also available for a natural, low-maintenance alternative.",
      },
      {
        title: "Professional Hair Services",
        text: "Precision cuts, color treatments, balayage, blowouts, and wedding updos by expert stylists. We use Kérastase professional products exclusively and accommodate men's and children's appointments alongside our full-service hair color and styling menu.",
      },
      {
        title: "Premium Tanning",
        text: "High-end UV tanning beds, professional airbrush tanning, and infrared pod wellness sessions. Each tanning service is tailored to achieve your desired glow with natural, even, streak-free results that complement your skin tone beautifully.",
      },
      {
        title: "Boutique & Loyalty Rewards",
        text: "Shop premium brands including Kérastase, RVCA, and Mangiacotti at our on-site boutique. Every service visit earns loyalty points redeemable for boutique discounts — our way of rewarding clients who choose The Lash Bar.",
      },
    ],
    benefits: [
      { title: "Voted Utah's Best Lashes", text: "Recognized by Utah Valley Magazine as the premier lash studio in the state." },
      { title: "4.9 Stars · 901 Reviews", text: "Among the highest-rated beauty studios across all of Lehi and Utah County." },
      { title: "Elite Certified Artists", text: "VIP and Diamond Lash Artists trained to the highest standards in the industry." },
      { title: "Gives Back Globally", text: "Every visit helps fund Melissa Watts' humanitarian missions worldwide." },
    ],
  },

  process: {
    eyebrow: "Your Experience",
    headline: "Your Journey to Flawless",
    steps: [
      {
        number: "01",
        title: "Consultation",
        description: "Begin with a personalized consultation. Your artist assesses your natural lashes, understands your lifestyle, and designs a custom look crafted specifically for you.",
        icon: "ri-user-voice-line",
      },
      {
        number: "02",
        title: "Custom Lash Design",
        description: "Your artist maps your perfect set — choosing length, curl, volume, and style to complement your unique features and enhance your natural beauty with precision.",
        icon: "ri-magic-line",
      },
      {
        number: "03",
        title: "Precision Application",
        description: "Relax as your certified artist applies every lash with surgical precision. Our meticulous technique ensures flawless results using only premium, professional-grade materials.",
        icon: "ri-sparkling-2-line",
      },
      {
        number: "04",
        title: "Aftercare Guidance",
        description: "Leave confident and beautiful with full aftercare guidance. We advise on maintenance, fill schedules, and at-home care to maximize longevity and keep lashes flawless.",
        icon: "ri-heart-3-line",
      },
    ],
  },

  whyChoose: {
    eyebrow: "The Lash Bar Difference",
    headline: "Why Clients Choose Lash Bar Utah",
    items: [
      {
        icon: "ri-award-line",
        title: "Utah's Most Awarded Studio",
        description: "Voted Utah's Best Lashes by Utah Valley Magazine — the only studio in the state to earn this distinction. Our results speak louder than any award.",
      },
      {
        icon: "ri-shield-check-line",
        title: "Uncompromising Hygiene Standards",
        description: "Sterilized tools, single-use applicators, and premium medical-grade adhesives for every client. Hygiene is not optional at The Lash Bar — it's non-negotiable.",
      },
      {
        icon: "ri-gem-line",
        title: "Premium Materials, Always",
        description: "Only professional-grade lash fibers, adhesives, and beauty products. No shortcuts, no substitutes — exclusively luxury-tier materials on your lashes.",
      },
      {
        icon: "ri-eye-line",
        title: "Precision Artistry",
        description: "Each lash applied individually with surgical precision. Our VIP and Diamond-certified artists deliver natural yet dramatic results with exceptional accuracy.",
      },
    ],
    image: whyChooseImage,
  },

  serviceAreas: {
    eyebrow: "Serving the Wasatch Front",
    headline: "Serving Lehi, Utah and Surrounding Areas",
    description:
      "Centrally located in Lehi, Utah — The Lash Bar is easily accessible to clients from Salt Lake City, Provo, American Fork, and all of Utah County. Premium lash extensions, hair, and tanning worth every mile.",
  },

  testimonials: {
    eyebrow: "Client Stories",
    headline: "Real Results. Real Clients.",
  },

  faq: {
    eyebrow: "Frequently Asked",
    headline: "Your Questions, Answered",
    items: [
      {
        question: "Who provides the best eyelash extensions near me in Lehi, Utah?",
        answer:
          "The Lash Bar in Lehi, Utah is voted Utah's best eyelash extensions studio. Our certified VIP and Diamond Lash Artists create stunning classic, volume, and hybrid sets — backed by 4.9 stars from over 901 Google reviews. We serve clients from across Utah County, Salt Lake City, and the entire Wasatch Front.",
      },
      {
        question: "How much do lash extensions cost at The Lash Bar?",
        answer:
          "Pricing varies by style, set complexity, and artist tier. Classic, volume, and hybrid extensions are offered at different investment levels to suit your goals. For current pricing, call us at (801) 473-2615 or book a consultation online — we'll find the right service for your budget and lifestyle.",
      },
      {
        question: "How long do lash extensions last before needing a fill?",
        answer:
          "Lash extensions typically last 2 to 4 weeks before a fill is recommended, depending on your natural lash cycle and aftercare habits. We provide detailed aftercare guidance after every appointment to help maximize retention and keep your lashes looking full, fresh, and flawless between visits.",
      },
      {
        question: "What makes The Lash Bar different from other studios in Utah?",
        answer:
          "We're the only Utah studio voted Utah's Best Lashes by Utah Valley Magazine, with a 4.9-star rating from over 901 reviews. Our VIP and Diamond-certified artists, strict hygiene protocols, premium materials, and founder Melissa Watts' global humanitarian mission set us apart from every other beauty studio.",
      },
      {
        question: "What tanning services are available at The Lash Bar?",
        answer:
          "We offer professional airbrush tanning for a natural streak-free glow, high-end UV tanning beds, and infrared pod wellness sessions. Each service is fully customized for your skin tone and desired result. Located in Lehi and serving clients from across Utah County and the greater Salt Lake City area.",
      },
      {
        question: "What are The Lash Bar's hours of operation?",
        answer:
          "We're open Monday and Friday 9AM–7PM, Tuesday through Thursday 9AM–8PM, Saturday 9AM–4PM, and Sunday 10AM–4PM. Book online anytime or call (801) 473-2615 to check same-day availability with your preferred artist at our Lehi, Utah studio.",
      },
    ],
  },

  finalCTA: {
    eyebrow: "Your Transformation Awaits",
    headline: "Reserve Your Appointment Today",
    subtext:
      "Join hundreds of clients across Salt Lake City, Lehi, American Fork, Orem, and all of Utah County who trust The Lash Bar for a premium beauty experience that delivers real, lasting results.",
  },
};

export default function HomePage() {
  return <PageTemplate data={homeData} />;
}
